import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
const OWID_VACCINE_URL = 'https://www.data4life.care/owid.eu.vaccines.json';

Chart.register(...registerables);
Chart.register(ChartDataLabels);

class CoronaVaccineProgress {
  constructor(element) {
    this.buttons = element.querySelectorAll('.vaccineProgress__buttons button');
    this.chartContainer = element.querySelector('.vaccineProgress__chart');
    this.chart = this.chartContainer.querySelector('canvas');
    this.lang = document.documentElement.lang;
    this.countries = {
      Austria: 'Österreich',
      Belgium: 'Belgien',
      Czechia: 'Tschechien',
      France: 'Frankreich',
      Germany: 'Deutschland',
      Greece: 'Griechenland',
      Italy: 'Italien',
      Netherlands: 'Niederlande',
      Poland: 'Polen',
      Portugal: 'Portugal',
      Russia: 'Russland',
      Spain: 'Spanien',
      Switzerland: 'Schweiz',
      'United Kingdom': 'Vereinigtes Königreich',
    };

    // Sets height to allocate vertical space
    this.chartContainer.style.setProperty('--count', Object.keys(this.countries).length);

    // First init chart, then populate data...
    this.initChart();
    this.getData();

    // ...so we can update upon filter
    this.buttons.forEach((button) => {
      button.addEventListener('click', (btn) => {
        if (btn.target.classList.contains('button--ghost')) {
          this.buttons.forEach((btn) => btn.classList.add('button--ghost'));
          btn.target.classList.remove('button--ghost');

          this.sortData(btn.target.dataset.type);
        }
      });
    });
  }

  formatLocations(sorted) {
    return [
      ...sorted
        .map((country) =>
          document.documentElement.lang === 'en' ? country.location : this.countries[country.location]
        )
        .map((country) => (country.indexOf(' ') > 0 ? country.split(' ') : country)),
    ];
  }

  getData() {
    fetch(OWID_VACCINE_URL)
      .then((response) => response.json())
      .then((data) => {
        this.data = data.filter((country) => {
          return this.countries.hasOwnProperty(country.location);
        });
        this.sortData();
      });
  }

  sortData(type = 'total_vaccinations') {
    const sorted = this.data.sort((a, b) => b[`${type}_per_hundred`] - a[`${type}_per_hundred`]);
    const dataset = [];

    if (type === 'total_vaccinations') {
      dataset.push({
        data: [...sorted.map((country) => Math.round(country[`${type}_per_hundred`]))],
      });
      this.chart.options.plugins.tooltip.enabled = false;
    } else {
      const datalabelsOptions = {
        display: 'auto',
        formatter: function (value) {
          return value + '%';
        },
      };
      dataset.push({
        label: translationObject.fulllabel,
        data: [...sorted.map((country) => Math.round(country.people_fully_vaccinated_per_hundred))],
        backgroundColor: '#bdd4f0',
        datalabels: datalabelsOptions,
      });
      dataset.push({
        label: translationObject.partiallabel,
        data: [...sorted.map((country) => Math.round(country[`${type}_per_hundred`]))],
        backgroundColor: '#d7eecb',
        datalabels: datalabelsOptions,
      });
      this.chart.options.plugins.tooltip.enabled = true;
    }

    this.chart.data = {
      labels: this.formatLocations(sorted),
      datasets: dataset,
    };
    this.chart.update();
  }

  initChart() {
    this.chart = new Chart(this.chart, {
      type: 'bar',
      options: {
        barThickness: 25,
        backgroundColor: '#ffdbcf',
        indexAxis: 'y',
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              color: '#acaba8',
            },
            ticks: {
              display: false,
            },
          },
          y: {
            stacked: true,
            grid: {
              display: false,
            },
            ticks: {
              color: '#000e8e',
              font: {
                size: 18,
                family: 'GT-America',
                lineHeight: 1,
              },
              autoSkip: false,
            },
            afterFit: function (scaleInstance) {
              scaleInstance.width = 120;
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            mode: 'index',
            titleFont: {
              size: 14,
              weight: 500,
              family: 'GT-America',
            },
            bodyFont: {
              size: 14,
              family: 'GT-America',
            },
            callbacks: {
              title: function (t) {
                return `${t[0].label.replace(',', ' ')}`;
              },
              label: function (d) {
                return `${d.dataset.label}: ${d.formattedValue}%`;
              },
            },
          },
          datalabels: {
            font: {
              size: 14,
              family: 'GT-America',
            },
            color: '#000e8e',
            anchor: 'end',
            align: 'start',
          },
        },
      },
    });
  }
}

const init = () => {
  [...document.querySelectorAll('.js-vaccineProgress')].forEach((el) => {
    new CoronaVaccineProgress(el);
  });
};

export { init };
